import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import AuthFooter from "../../containers/footer/AuthFooter";
import PersonIcon from "@material-ui/icons/Person";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { useHistory } from "react-router";

import {
  //ログイン処理
  fetchAsyncLogin,
  //登録処理
  fetchAsyncRegister,
  //プロフィール新規作成
  fetchAsyncCreateProfile,
  //ログインor登録のstate
  selectIsLoginView,
  selectIsError,
  fetchAsyncLoginUserJWT,
  fetchAsyncGetJWT,
} from "./authSlice";

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {"Copyright © "}
//       <Link color="inherit" href="https://material-ui.com/">
//         Your Website
//       </Link>{" "}
//       {new Date().getFullYear()}
//       {"."}
//     </Typography>
//   );
// }

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
    position: "relative",
  },
  image: {
    backgroundImage: "url(https://source.unsplash.com/random)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#2699FB",
  },
  submitGuest: {
    margin: theme.spacing(2, 0, 3),
    backgroundColor: "#33cc99",
    "&:hover": {
      backgroundColor: "#003333",
    },
  },
  error: {
    margin: theme.spacing(3, 0),
    color: "#cc3333",
    fontSize: 12,
  },
  passError: {
    fontSize: 12,
    width: "100%",
    color: "#f44336",
  },
  circulContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 3,
  },
  circul: {
    height: "100px !important",
    width: "100px !important",
  },
}));

const Auth: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const isLoginView = useSelector(selectIsLoginView);
  const [isLoading, setIsLoading] = useState(false);
  const [credential, setCredential] = useState({
    email: "",
    password1: "",
    password2: "",
  });

  const [username, setUsername] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const isError = useSelector(selectIsError);
  //email と　パスワード用
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let str = e.target.value;
    const name = e.target.name;

    str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    str = str.replace(/[^!-~]/g, "");

    setCredential({ ...credential, [name]: str });
  };

  //username用
  const handleInputChangeUsername = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    // setCredential({ ...credential, username: e.target.value });
    setUsername(e.target.value);
  };

  //ゲストログイン
  const guest = async () => {
    setIsLoading(true);
    const result = await dispatch(
      fetchAsyncLogin({
        email: "test@gmail.com",
        password1: "Teti0000",
        password2: "Teti0000",
      })
    );
    if (fetchAsyncLogin.fulfilled.match(result)) {
      await dispatch(
        fetchAsyncGetJWT({
          email: "test@gmail.com",
          password1: "Teti0000",
          password2: "Teti0000",
        })
      );
      setIsLoading(false);
      window.location.href = "/home";
    }
    setIsLoading(false);
  };

  const login = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    if (isLoginView) {
      const result = await dispatch(fetchAsyncLogin(credential));
      if (fetchAsyncLogin.fulfilled.match(result)) {
        await dispatch(fetchAsyncGetJWT(credential));
        setIsLoading(false);
        window.location.href = "/home";
      }
      setIsLoading(false);
    } else {
      //パスワード再入力が合っているか確認
      if (credential.password1 === credential.password2) {
        setPasswordError(false);
        const result = await dispatch(fetchAsyncRegister(credential));
        //仮登録終了後、プロフィールデータを作成
        if (fetchAsyncRegister.fulfilled.match(result)) {
          await dispatch(fetchAsyncGetJWT(credential));
          await dispatch(fetchAsyncCreateProfile(username));
          await localStorage.removeItem("localJWT");
          setIsLoading(false);
          window.location.href = "/signup_done";
        }
        setIsLoading(false);
      } else {
        setPasswordError(true);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    dispatch(fetchAsyncLoginUserJWT());
  }, []);

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      {/* <Grid item xs={false} sm={4} md={7} className={classes.image} /> */}
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        {isLoading && (
          <div className={classes.circulContainer}>
            <CircularProgress className={classes.circul} />
          </div>
        )}

        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            {isLoginView ? "Login" : "Sign up"}
          </Typography>
          {/* バックエンドのバリデーションにかかった場合 */}
          {/* ログイン画面はemail passが違う */}
          {/* 登録画面はemailが存在している */}
          {isError ? (
            isLoginView ? (
              <div className={classes.error}>
                有効なメールアドレス・パスワードを入力してください
              </div>
            ) : (
              <div className={classes.error}>
                有効なメールアドレスを入力してください
              </div>
            )
          ) : (
            ""
          )}
          <form className={classes.form} onSubmit={login}>
            {isLoginView ? (
              ""
            ) : (
              <TextField
                margin="normal"
                fullWidth
                required
                id="username"
                label="ユーザ名(15文字以内)"
                name="username"
                autoComplete="username"
                hidden={true}
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                  inputProps: { maxLength: 15 },
                }}
                value={username}
                onChange={handleInputChangeUsername}
              />
            )}

            <TextField
              margin="normal"
              fullWidth
              required
              id="email"
              label="メールアドレス"
              name="email"
              type="email"
              autoComplete="email"
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
              value={credential.email}
              onChange={handleInputChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password1"
              label="パスワード(半角8文字以上)"
              type="password"
              id="password"
              autoComplete="current-password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                inputProps: { minLength: 8, maxLength: 20 },
              }}
              value={credential.password1}
              onChange={handleInputChange}
            />
            {isLoginView ? (
              ""
            ) : (
              <TextField
                margin="normal"
                error={passwordError}
                required
                fullWidth
                name="password2"
                label="パスワード再入力"
                type="password"
                id="re-password"
                autoComplete="current-password"
                onChange={handleInputChange}
                value={credential.password2}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  inputProps: { minLength: 8, maxLength: 20 },
                }}
              />
            )}
            {passwordError && (
              <div className={classes.passError}>
                パスワード再入力が一致しません。
              </div>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              //   onClick={login}
            >
              {isLoginView ? "ログイン" : "登録"}
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submitGuest}
              onClick={guest}
            >
              ゲストログイン
            </Button>
            {isLoginView ? (
              <Grid container>
                <Grid item xs>
                  <Link
                    variant="body2"
                    onClick={() => history.push("/password_reset")}
                  >
                    パスワードをお忘れの場合
                  </Link>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </form>
        </div>
        <AuthFooter />
      </Grid>
    </Grid>
  );
};

export default Auth;
